// In-flow doctor letterhead (classic affiliations grid or multi-clinic layout).
// Designed to live inside a table <thead> so print repeats it on every page.
function safe(v, fb = "") { return v === undefined || v === null ? fb : v; }

export default function Letterhead({ doctor = {}, s = {}, affiliations = [], isMulti = false, hideLicense = false }) {
  const clinics = Array.isArray(doctor.clinics) ? doctor.clinics : [];
  const affs = Array.isArray(affiliations) && affiliations.length
    ? affiliations
    : (Array.isArray(s.affiliations) ? s.affiliations : []);

  if (isMulti) {
    return (
      <div className="pb-3 border-b-2 border-slate-800" style={{ display: "grid", gridTemplateColumns: "42% 58%", columnGap: "6mm", alignItems: "flex-start" }}>
        <div>
          <div style={{ fontFamily: "Work Sans", fontWeight: 800, fontSize: "15pt", lineHeight: 1.05, color: "#1a2a7a" }}>
            {safe(doctor.name, s.doctor_name) || "DOCTOR NAME, MD"}
          </div>
          {safe(doctor.specialty, s.specialty) ? (
            <div style={{ fontSize: "9pt", marginTop: "1mm", color: "#0e7c7b", fontWeight: 600 }}>{safe(doctor.specialty, s.specialty)}</div>
          ) : null}
          {hideLicense ? null : (
            <div className="text-[8pt] text-slate-600 mt-0.5">
              Lic. No.: {safe(doctor.license_number, s.license_number) || "—"} · PTR No.: {safe(doctor.ptr_number, s.ptr_number) || "—"}
            </div>
          )}
        </div>
        <div style={{ fontSize: "7.5pt", lineHeight: 1.3, color: "#0f172a" }}>
          {clinics.map((c, i) => (
            <div key={i} style={{ padding: "0.4mm 0", borderBottom: i < clinics.length - 1 ? "0.3pt dotted #cbd5e1" : "none" }}>
              <b>{safe(c.name)}{c.name ? ":" : ""}</b> {safe(c.schedule)}{c.contact ? ` CP: ${c.contact}` : ""}
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="pb-3 border-b-2 border-slate-800">
      <div className="text-center">
        <div className="font-bold text-slate-900" style={{ fontFamily: "Work Sans, Arial, sans-serif", fontSize: "15pt", letterSpacing: "0.01em", lineHeight: 1.08 }}>
          {safe(doctor.name, s.doctor_name) || "DOCTOR NAME, MD"}
        </div>
        {(safe(doctor.specialty, s.specialty)) ? (
          <div className="text-slate-800 mt-0.5" style={{ fontFamily: "Arial, sans-serif", fontSize: "9pt", lineHeight: 1.15 }}>{safe(doctor.specialty, s.specialty)}</div>
        ) : null}
        {hideLicense ? null : (
          <div className="text-[8pt] text-slate-600 mt-0.5">
            Lic. No.: {safe(doctor.license_number, s.license_number) || "—"} · PTR No.: {safe(doctor.ptr_number, s.ptr_number) || "—"}
          </div>
        )}
      </div>

      {affs.length > 0 ? (
        <div
          className="mt-2 text-[7pt] leading-[1.12] text-slate-900"
          style={{ fontFamily: "Arial, sans-serif", display: "grid", gridTemplateColumns: "1.05fr 0.95fr 1.1fr", columnGap: "8mm" }}
        >
          {affs.map((af, ai) => (
            <div key={ai}>
              {ai === 0 ? <div className="italic underline mb-0.5">Affiliations:</div> : null}
              <div className="font-bold uppercase">{af.name}</div>
              {(af.lines || []).map((ln, li) => {
                const isHospitalLine = /^[A-Z][A-Z .,&]+$/.test(ln) && ln.length > 6 && ln === ln.toUpperCase();
                return (
                  <div key={li} className={isHospitalLine ? "font-bold uppercase" : ""}>{ln}</div>
                );
              })}
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
